module.exports = __webpack_public_path__ + "static/media/icon_factory_list.71fcaabf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_factory_list.png
// module id = 3644
// module chunks = 0